import { Grid, Typography } from "@mui/material";
import { AsyncSelect, ControlledDatePicker, ControlledTextField } from "src/components/forms";
import CardActions from "../../../components/CardActions";
import { UseFormReturn } from "react-hook-form";
import { OperacionWRM, OperacionWRMFields } from "../api";
import { FormOperacionWRM } from "../types/types";
import { useOperacion } from "src/pages/sistema/hooks/useOperacion";
import { HttpCacheOperacion } from "src/pages/sistema/api/httpCacheOperacion";
import { dateFormatter } from "src/utils/formatters";
import {SectorComercialFields} from "../../../../../types";
import {SistemaTipo} from "../../../../../types/enum/enum";
import {useSectoresComerciales} from "../../../../messages/api/useSectoresComerciales";
import {useLoadOptions} from "../../../../../hooks/useLoadOptions";

const SchemaFields = OperacionWRMFields

type DatosOperacionProps = {
    formMethods: UseFormReturn<FormOperacionWRM>
    readOnly?: boolean
    operacion?: OperacionWRM
    codSistemaPrincipal: number
    codSistema: number
    nuevo?: boolean
}

const SeccionWRMDatosOperacion = ({ formMethods, readOnly, operacion, codSistemaPrincipal, codSistema, nuevo }: DatosOperacionProps) => {
    const { control, watch } = formMethods

    const sectoresHook = useSectoresComerciales(codSistema)

    const loadSectoresComerciales = useLoadOptions({
        data: sectoresHook.sectores,
        loading: sectoresHook.loading,
        isError: sectoresHook.isError,
        error: sectoresHook.error
    });

    return (
        <CardActions title='Datos Operación' colapsable>
            <Grid container spacing={4}>
                {
                    !nuevo &&
                    <Grid item xs={12} md={3}>
                        <Typography variant='body2'>Usuario Alta</Typography>
                        <Typography>{operacion && `${operacion.nombreUsuarioAlta} ${operacion.apellidoUsuarioAlta}`}</Typography>
                    </Grid>
                }
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Sector Comercial</Typography>
                                <Typography>{operacion?.nombreSectorComercial || '-'}</Typography>
                            </> :
                            <AsyncSelect
                                control={control}
                                name={SchemaFields.CodSectorComercial}
                                label='Sector Comercial'
                                loadOptions={loadSectoresComerciales}
                                valueField={SectorComercialFields.SectorComercialCodigo}
                                fullWidth
                            />
                    }
                </Grid>
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Fecha Aprobación</Typography>
                                <Typography>{operacion && dateFormatter.toShortDate(operacion?.fechaEmision)}</Typography>
                            </> :
                            <ControlledDatePicker
                                name={SchemaFields.FechaEmision}
                                label='Fecha Aprobación'
                                control={control}
                                selectedSections={undefined}
                                fullWidth
                                readOnly={readOnly}
                            />
                    }
                </Grid>
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Fecha Vencimiento</Typography>
                                <Typography>{operacion ? dateFormatter.toShortDate(operacion?.fechaVencimiento) : '-'}</Typography>
                            </> :
                            <ControlledDatePicker
                                name={SchemaFields.FechaVencimiento}
                                label='Fecha Vencimiento'
                                control={control}
                                selectedSections={undefined}
                                minDate={watch(OperacionWRMFields.FechaEmision)}
                                fullWidth
                                readOnly={readOnly}
                            />
                    }
                </Grid>
                <Grid item xs={12}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Observaciones</Typography>
                                <Typography>{operacion?.observaciones || '-'}</Typography>
                            </> :
                            <ControlledTextField
                                name={SchemaFields.Observaciones}
                                label='Observaciones'
                                control={control}
                                multiline
                                rows={4}
                                fullWidth
                                InputProps={{
                                    readOnly: readOnly
                                }}
                            />
                    }
                </Grid>
            </Grid>
        </CardActions>
    )
}

export default SeccionWRMDatosOperacion
